import iraceLogo from '../assets/irace-logo.png';
import { COPY } from '../copy/vi.ts';

/**
 * The landing screen at `/`, outside the UI spec.
 *
 * Every participant is meant to arrive through a QR code at `/e/:slug`, so the
 * bare domain has no event to show. It used to fall through to the M01
 * "not found" screen, which tells someone who typed the address by hand that
 * the site is broken rather than that they need a code.
 */
export function Home() {
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-[480px] flex-col items-center justify-center gap-6 p-8 text-center">
      <img src={iraceLogo} alt="iRace" className="w-35" />
      <p className="text-base leading-relaxed text-text-muted">{COPY.home.tagline}</p>
    </div>
  );
}
